// src/store/modules/permission.js
import { asyncRoutes } from '@/router/asyncRoutes'

/**
 * 根据权限标识数组过滤路由树
 * @param {Array} routes 完整路由树
 * @param {Array} permissions 权限标识数组
 * @returns {Array} 过滤后的路由树
 */
function filterRoutes(routes, permissions) {
  const res = []
  routes.forEach(route => {
    // 浅拷贝，避免修改原路由对象
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = filterRoutes(tmp.children, permissions)
    }
    // 如果路由有 name 且在权限数组中，或者有子路由（子路由有权限），则保留
    if (
      (tmp.name && permissions.includes(tmp.name)) ||
      (tmp.children && tmp.children.length > 0)
    ) {
      res.push(tmp)
    }
  })
  return res
}

const state = {
  menuList: [] // 过滤后的菜单树（用于侧边栏）
}

const mutations = {
  SET_MENU_LIST(state, list) {
    console.log('提交保存目录树',list)
    state.menuList = list
  }
}

const actions = {
  generateRoutes({ commit }, permissions) {
    console.log(permissions,'permissions')
    return new Promise(resolve => {
      const accessedRoutes = filterRoutes(asyncRoutes, permissions)
      commit('SET_MENU_LIST', accessedRoutes)
      resolve(accessedRoutes)
      console.log(state.menuList,'state.menuList')
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}